import { useState } from "react";
import { verifyAdmissionNumber } from "@services/authenticationService";
import { useLoginGateway } from "@hooks/store";

type UseVerifyAdmissionOptions = {
  onSuccess: (phone: string) => void;
};

export function useVerifyAdmission({ onSuccess }: UseVerifyAdmissionOptions) {
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const loginGateway = useLoginGateway();

  const verify = async (admissionNo: string) => {
    setError("");
    setIsVerifying(true);
    try {
      const res = await verifyAdmissionNumber(admissionNo, loginGateway);
      if (res?.existingUser) {
        onSuccess(res?.phone);
      } else {
        setError("Please enter a valid User ID");
      }
    } catch {
      setError("Error verifying User ID");
    } finally {
      setIsVerifying(false);
    }
  };

  return { error, setError, isVerifying, verify };
}
